import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppConfigService } from '../../../core/services/app-config.service';

@Component({
  selector: 'eos-practice-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './practice-header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './practice-header.component.scss',
})
export class PracticeHeaderComponent implements OnInit {
  private appConfigService = inject(AppConfigService);

  practiceName = '';

  ngOnInit(): void {
    this.appConfigService
      .getPracticeName$()
      .subscribe((data) => (this.practiceName = data));
  }
}
